import React, { useId, useRef, useState } from 'react';
import { useOverflowing } from './useOverflowing';

interface Props {
  text: string;
  className?: string;
}

// Text cut to two lines, with Show more when (and only when) it is cut off. The line
// breaks the writer typed are kept (#1008).
const ExpandableText: React.FC<Props> = ({ text, className }) => {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);
  const overflowing = useOverflowing(ref, [text, expanded]);
  const id = useId();
  const classes = ['expandable-text', expanded ? '' : 'expandable-text--clamped', className ?? ''].filter(Boolean).join(' ');
  return (
    <>
      <p id={id} ref={ref} className={classes}>{text}</p>
      {(expanded || overflowing) && (
        <button
          type="button"
          className="expandable-text-toggle"
          aria-expanded={expanded}
          aria-controls={id}
          onClick={() => setExpanded(v => !v)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </>
  );
};

export default ExpandableText;
